import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async () => {
  return await dponetAPI.get('/dai_opt_out')
}

const manage = async ({ daiOptOut }) => {
  return await dponetAPI.patch('/dai_opt_out', {
    daiOptOut,
  })
}

export default {
  get,
  manage,
}
